import { ApiOrderTransaction } from '@api/interfaces/ApiOrderTransaction';
import { ApiOrderTransactionProduct } from '@api/interfaces/ApiOrderTransactionProduct';
import { TransactionType } from '@shared/enums';
import { formatCurrency, formatNumber } from '@shared/utilities';
import { TFunction } from 'i18next';

export const getOrderLabel = (
  order: Pick<ApiOrderTransaction, 'externalId'>,
  t: TFunction,
) => t($ => $.customers.updatePoints.orderNumber, { externalId: order.externalId });

export const getOrderProductLabel = (
  orderProduct: ApiOrderTransactionProduct,
  i18n: { language: string },
) => {
  const { product, quantity, subtotal, uom } = orderProduct;
  const quantityLabel = quantity === null
    ? null
    : `${formatNumber(quantity, i18n)}${uom ? ` ${uom}` : ''}`;
  return [
    product?.name ?? product?.externalId ?? '',
    quantityLabel,
    subtotal === null ? null : formatCurrency(subtotal, i18n),
  ].filter(Boolean).join(' · ');
};

export const getPointsEntryLabel = (type: TransactionType, t: TFunction): string => {
  switch (type) {
    case TransactionType.CREDIT:
      return t($ => $.customerDashboard.pointsActivity.pointsEarned);
    case TransactionType.BOOKING_REDEMPTION:
    case TransactionType.BOOKING_REFUND:
    case TransactionType.DEBIT:
    case TransactionType.DEBIT_CORRECTION:
      return t($ => $.bookings.filters.pointsRedeemed);
    case TransactionType.REDEMPTION_REFUND:
    case TransactionType.REDEMPTION_REFUND_CORRECTION:
      return t($ => $.bookings.filters.pointsRefunded);
    case TransactionType.RETURN:
      return t($ => $.bookings.filters.pointsReturned);
    case TransactionType.CORRECTION:
    case TransactionType.RETURN_CORRECTION:
      return t($ => $.bookings.filters.pointsCorrected);
    default:
      return t($ => $.customerDashboard.pointsActivity.adjustment);
  }
};
